module.exports = __webpack_public_path__ + "media/images/admin2/AdminAgenciesDetails__section__dl__item-93701e044a29580051a8b0ce638e5385.svg";